import {AverageBallCalculation} from './enroll-attestat-average-calculation';

export class EnrollAttestat {
  attestat_series: string = '';
  attestat_number: string = '';
  attestat_give_date: Date;
  attestat_with_distinction: number = null;
  gold_medal: number = null;
  attestat_average_ball: string = null;
  attestat_scan: any;
  attestat_app_scan: any;
  averageBallCalculation: AverageBallCalculation = new AverageBallCalculation();
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/edu-info/enroll-attestat.ts